export const colors = {
  black: '#000000',
  red: '#f44336',
  yellow: '#FFEB3B',
  green: '#4CAF50',
};



// WEBPACK FOOTER //
// ./src/data/colorcodes.js